// Wie ein Thread heisst — an EINER Stelle, weil die Regel sonst driftet: die Liste zeigte den
// Kanal-Titel als Ersatz, Detail-Kopf und Kontext-Panel nicht, und derselbe Thread hiess links
// "Tobe GA" und rechts "Gast".
//
// `guestName` steht nur, wenn eine Buchung mit Gastprofil verknuepft ist. Fehlt sie — Anfrage ohne
// Buchung, oder die Buchung ist bei uns (noch) nicht angekommen — traegt `subject` den Namen: es
// ist der Thread-Titel des Kanals, und der ist in aller Regel der Gastname.
export function threadDisplayName(
  guestName: string | null | undefined,
  subject: string | null | undefined,
): string | null {
  return guestName?.trim() || subject?.trim() || null;
}
